module.exports = {"410306002":"西霞院街道","410306003":"康乐街道","410306004":"吉利街道","410306005":"河阳街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410306.json
// module id = 1542
// module chunks = 0